<div class="allocated-asset-info">
  <mat-dialog-content>
    <div class="title">
      <app-title-field [title]="'Add / Replace Asset'"></app-title-field>
      <div class="close-button">
        <button mat-icon-button (click)="cancel()" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-content>
  <form [formGroup]="form" class="asset-form" novalidate>
    <!-- Action -->
    <div class="form-section">
      <app-dropdown
        class="emerald-dropdown"
        [options]="actionOptions"
        [valueKey]="'value'"
        [outlined]="true"
        [displayKey]="'label'"
        [label]="'Select Action*'"
        formControlName="action"
      >
      </app-dropdown>
      <div class="error" *ngIf="hasError('action', 'required')">Required.</div>

      <!-- Additional Search Resource Email for Replace action -->
      <div class="email-search-container">
        <div style="display: flex; align-items: flex-start; gap: 8px">
          <mat-form-field
            class="autocomplete-field emerald-dropdown"
            appearance="outline"
            floatLabel="always"
            style="flex: 1; margin-bottom: 0"
          >
            <mat-label>Search Resource Email*</mat-label>
            <input
              #replaceEmailAutoInput
              type="text"
              matInput
              placeholder="Type to search resource email"
              [matAutocomplete]="autoReplaceEmail"
              [formControl]="replaceEmailSearchControl"
            />
            <mat-autocomplete
              #autoReplaceEmail="matAutocomplete"
              [displayWith]="displayEmailFn"
              (optionSelected)="onReplaceEmployeeEmailOptionSelected($event)"
            >
              <mat-option
                *ngFor="let option of replaceEmailOptions"
                [value]="option.value"
              >
                {{ option.label }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div *ngIf="replaceEmailNotFoundError" class="error">
          {{ replaceEmailNotFoundError }}
        </div>
      </div>
    </div>
    <div *ngIf="form.get('action')?.value === 'replace'" class="form-section">
      <div *ngIf="showEmployeeSearch" class="email-search-container">
        <div style="display: flex; align-items: flex-start; gap: 8px">
          <mat-form-field
            class="autocomplete-field emerald-dropdown"
            appearance="outline"
            floatLabel="always"
            style="flex: 1; margin-bottom: 0"
          >
            <mat-label>Search Employee Email*</mat-label>
            <input
              #emailAutoInput
              type="text"
              matInput
              placeholder="Type to search employee email"
              [matAutocomplete]="autoEmail"
              [formControl]="emailSearchControl"
            />
            <mat-autocomplete
              #autoEmail="matAutocomplete"
              [displayWith]="displayEmailFn"
              (optionSelected)="onEmployeeEmailOptionSelected($event)"
            >
              <mat-option
                *ngFor="let option of emailOptions"
                [value]="option.value"
              >
                {{ option.label }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <!-- Show CC buttons only for Replace action -->
          <app-button-group
            *ngIf="form.get('action')?.value === 'replace'"
            [buttonType]="'Primary'"
            [buttonUseCase]="'add'"
            [label]="'Add to TO'"
            [disabled]="false"
            (click)="onEmployeeEmailButtonClick()"
            style="margin-bottom: 12px"
          >
          </app-button-group>
          <app-button-group
            *ngIf="form.get('action')?.value === 'replace'"
            [buttonType]="'Secondary'"
            [buttonUseCase]="'add'"
            [label]="'Add to CC'"
            [disabled]="false"
            (click)="onEmployeeEmailCcButtonClick()"
            style="margin-bottom: 12px"
          >
          </app-button-group>
        </div>
        <div
          *ngIf="duplicateEmailError"
          class="email-error-message"
          style="color: #d32f2f; margin-bottom: 8px"
        >
          {{ duplicateEmailError }}
        </div>
        <div class="error" *ngIf="hasError('email', 'required')">
          Resource Email is required.
        </div>
        <div class="error" *ngIf="emailNotFoundError">
          {{ emailNotFoundError }}
        </div>
      </div>
    </div>

    <!-- Employee Email Search (only for Add action without pre-selected employee or Replace action) -->

    <!-- Email Display Sections - Only for Replace action -->
    <div
      *ngIf="showEmployeeSearch && form.get('action')?.value === 'replace'"
      class="email-container"
    >
      <div class="email-sections-wrapper">
        <div
          class="email-section email-section-left"
          *ngIf="toEmails.length > 0"
        >
          <h4>TO Email :</h4>
          <div class="email-list email-list-horizontal">
            <div
              class="email-item"
              *ngFor="let email of toEmails; let i = index"
            >
              <span class="email-text">{{ email }}</span>
              <button
                class="email-remove-btn"
                (click)="removeToEmail(i)"
                type="button"
                aria-label="Remove email"
              >
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>
        </div>
        <div
          class="email-section email-section-right"
          *ngIf="ccEmails.length > 0"
        >
          <h4>CC Email :</h4>
          <div class="email-list email-list-horizontal">
            <div
              class="email-item"
              *ngFor="let email of ccEmails; let i = index"
            >
              <span class="email-text">{{ email }}</span>
              <button
                class="email-remove-btn"
                (click)="removeCcEmail(i)"
                type="button"
                aria-label="Remove email"
              >
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="no-emails"
        *ngIf="toEmails.length === 0 && ccEmails.length === 0"
      >
        <p>No email notifications selected.</p>
      </div>
    </div>

    <!-- Laptop -->
    <app-title-field [title]="'New Asset/Accessories Details'"></app-title-field>
    <div class="form-section" >
      <div class="laptop">
        <app-dropdown
          class="emerald-dropdown dropdown-cls"
          [valueKey]="'value'"
          [outlined]="true"
          [displayKey]="'label'"
          [label]="'Laptop'"
          formControlName="laptop"
          [disabled]="form.get('laptop')?.disabled ?? true"
        >
        </app-dropdown>
      </div>

      <!-- OS Type, Laptop Brand, and Laptop Type - Only for Replace action -->
      <div *ngIf="form.get('action')?.value === 'replace'">
        <!-- OS Type -->
        <div class="field-container">
          <app-dropdown
            class="emerald-dropdown"
            [options]="osTypeOptions"
            [label]="'OS Type'"
            [outlined]="true"
            [displayKey]="'label'"
            [required]="true"
            [valueKey]="'value'"
            formControlName="osType"
            [required]="true"
            (selectionChange)="onOsTypeChange($event)"
          >
          </app-dropdown>

          <div class="error" *ngIf="hasError('osType', 'required')">
            OS Type is required.
          </div>
        </div>
</div>
<div *ngIf="form.get('action')?.value === 'replace'">
        <div class="field-container">
          <app-dropdown
            class="emerald-dropdown"
            [options]="brandNameOptions"
            [label]="'Laptop Brand'"
            [outlined]="true"
            [displayKey]="'label'"
            [required]="true"
            [valueKey]="'value'"
            formControlName="brandName"
            [required]="true"
            (selectionChange)="onBrandNameChange($event)"
          >
          </app-dropdown>

          <div class="error" *ngIf="hasError('brandName', 'required')">
            Laptop Brand is required.
          </div>
        </div>
</div>
<div *ngIf="form.get('action')?.value === 'replace'">
        <!-- Laptop Type -->
        <div class="field-container">
          <app-dropdown
            class="emerald-dropdown"
            [options]="laptopTypeOptions"
            [label]="'Laptop Type'"
            [outlined]="true"
            [displayKey]="'label'"
            [required]="true"
            [valueKey]="'value'"
            formControlName="laptopType"
            [required]="true"
          >
          </app-dropdown>

          <div class="error" *ngIf="hasError('laptopType', 'required')">
            Laptop Type is required.
          </div>
        </div>
        </div>
  

      <!-- Laptop Serial Number -->
      <div class="field-container"  *ngIf="form.get('action')?.value === 'replace'">
        <app-input-field
          class="emerald-dropdown"
          [label]="'Laptop S/N*'"
          [type]="'text'"
          formControlName="laptopSerialNumber"
          [disabled]="form.get('laptopSerialNumber')?.disabled ?? false"
        >
        </app-input-field>
        <div class="error" *ngIf="hasError('laptopSerialNumber', 'required')">
          Laptop Serial number must be provided when replacing a laptop.
        </div>
        <div class="error" *ngIf="hasError('laptopSerialNumber', 'maxlength')">
          Max 120 characters.
        </div>
      </div>

      <!-- Charger Serial Number -->
      <div class="field-container" *ngIf="form.get('action')?.value === 'replace'">
        <app-input-field
          class="emerald-dropdown"
          [label]="'Charger S/N*'"
          [type]="'text'"
          formControlName="chargerSerialNumber"
          [disabled]="form.get('chargerSerialNumber')?.disabled ?? false"
        >
        </app-input-field>
        <div class="error" *ngIf="hasError('chargerSerialNumber', 'required')">
          Charger Serial number must be provided when replacing a laptop.
        </div>
        <div class="error" *ngIf="hasError('chargerSerialNumber', 'maxlength')">
          Max 120 characters.
        </div>
      </div>

      <!-- Accessories Type -->
      <div class="field-container">
        <app-dropdown
          class="emerald-dropdown"
          [options]="accessoriesTypeOptions"
          [valueKey]="'value'"
          [outlined]="true"
          [displayKey]="'label'"
          [label]="getAccessoriesTypeLabel()"
          formControlName="accessoriesType"
          [multiSelect]="true"
          [showCheckbox]="true"
          [disabled]="isLoadingAccessories"
          (selectionChange)="onAccessoriesChange($event)"
        >
        </app-dropdown>
        <div
          class="error"
          *ngIf="hasError('accessoriesType', 'required') && isActionAdd()"
        >
          Accessories Type must be provided.
        </div>
      </div>

      <!-- Date of Pickup -->
      <div class="field-container" *ngIf="form.get('action')?.value === 'replace'">
        <mat-form-field appearance="outline">
          <mat-label>Date of Pickup</mat-label>
          <input
            matInput
            [matDatepicker]="pickupPicker"
            placeholder="Select date"
            formControlName="dateOfPickup"
          />
          <mat-datepicker-toggle matSuffix [for]="pickupPicker"></mat-datepicker-toggle>
          <mat-datepicker #pickupPicker></mat-datepicker>
        </mat-form-field>
        <div class="error" *ngIf="hasError('dateOfPickup','required')">
          Date of Pickup is required.
        </div>
      </div>
  </div>

    <!-- Comments -->
   
     
        <app-input-field 
          [label]="'Comments'"
          formControlName="comments"
          [type]="'textarea'"
          [rows]="3"
        >
        </app-input-field>
        <div class="error" *ngIf="hasError('comments', 'maxlength')">
          Max 1000 characters.
        </div>
 


    <!-- File Attachments -->
    <div>
      <app-file-upload
        [label]="getAttachmentLabel()"
        (fileSelected)="onAttachmentSelected($event)"
        (fileRemoved)="onAttachmentRemoved()"
      ></app-file-upload>
      <div
        *ngIf="
          isReplaceActionWithLaptop() &&
          !uploadedFileUrl &&
          attachedFiles.length === 0
        "
        class="error"
      >
        Attachment is mandatory for laptop replacement.
      </div>
      <div class="error" *ngIf="hasError('attachments', 'required')"></div>
    </div>

    <!-- Actions -->
    <mat-dialog-actions align="end">
      <div class="action-buttons">
        <app-button-group
          [label]="'Cancel'"
          [cssClass]="'cancel-btn'"
          [buttonType]="'Secondary'"
          [buttonUseCase]="'cancel'"
          (onEmit)="cancel()"
        >
        </app-button-group>
        <app-button-group
          [label]="'Submit'"
          [buttonType]="'Primary'"
          (onEmit)="submit()"
        >
        </app-button-group>
      </div>
    </mat-dialog-actions>
  </form>
</div>
